import { createActionName } from "redux/utility"

export const reducerName = "relations"

// Actions
export const RELATIONS = createActionName(reducerName, "RELATIONS")
